import React, {Fragment} from "react";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {getContestGameBar, getCurrentQuestion} from "modules/selectors";
import {getClassAccordingBoolean, getDashedValue} from "modules/utils/helpers";
import {Exists, StrikeCounter} from "components";
import {useLocation} from "react-router-dom";

const HeaderElement = styled.div`
	width: 100%;
	height: 60px;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 14px;

	background: ${({theme}) => theme.header.stats.background};
	color: ${({theme}) => theme.header.stats.color};
	text-align: center;

	span {
		transition: 0.25s;
	}

	div {
		display: flex;
		flex-direction: column;
	}

	span.active {
		font-style: normal;
		font-weight: 800;
		font-size: 18px;
		line-height: 160%;
		color: ${({theme}) => theme.colors.brand.primary};
	}

	span.correct {
		color: ${({theme}) => theme.playCard.correctColor};
		transform: scale(1.1);
	}
`;

export const StatsHeader: React.FC = () => {
	const {t} = useTranslation();
	const gameBar = useSelector(getContestGameBar);
	const question = useSelector(getCurrentQuestion);
	const className = getClassAccordingBoolean("correct", question?.isCorrect);
	const location = useLocation();
	const onSummary = location.pathname.includes("summary");
	const onLeaderboards = location.pathname.includes("leaderboards");

	if (onLeaderboards) {
		return null;
	}

	return (
		<HeaderElement>
			<Exists when={onSummary}>
				<Fragment>
					<div>
						<span className="active">{getDashedValue(gameBar?.bestToday)}</span>
						<span>{t("game.stats.today_best")}</span>
					</div>
				</Fragment>
			</Exists>

			<div>
				<span className={`active ${className}`}>
					{getDashedValue(gameBar?.contestPoints)}
				</span>
				<span>{t("game.stats.your_score")}</span>
			</div>

			<Exists when={!onSummary}>
				<StrikeCounter strikes={gameBar?.numberStrikes} />
			</Exists>

			<Exists when={onSummary}>
				<Fragment>
					<div>
						<span className="active">{getDashedValue(gameBar?.bestPersonal)}</span>
						<span>{t("game.stats.personal_best")}</span>
					</div>
				</Fragment>
			</Exists>
		</HeaderElement>
	);
};
